import { SearchResponseStructure } from "../Constants/SearchStructure";
/**
 * Fetches and maps search result data from backend JSON.
 * @returns {Promise<Array>} Array of formatted search results.
 */
export const fetchSearchResults = async () => {
  try {
    const response = await fetch("/api/mock/Search/SearchTabMockData.json"); // JSON path
    const jsonData = await response.json();

    if (jsonData.status !== "success" || !Array.isArray(jsonData.results)) {
      throw new Error(jsonData.message || "Invalid search data.");
    }

    const formattedResults = jsonData.results.map((item) => ({
      ...SearchResponseStructure, // Start with default structure
      id: item.id || "",
      type: item.type || "",
      name: item.name || "",
      imageURL: item.imageURL || "",
      description: item.description || "",
      tags: item.tags || [],
      location: item.location || "",
      isOnline: item.isOnline || false,
      canMessage: item.canMessage || false,
      canAudioCall: item.canAudioCall || false,
      canVideoCall: item.canVideoCall || false,
      canVisit: item.canVisit || false
    }));

    return formattedResults;
  } catch (error) {
    console.error("Error fetching search results:", error);
    return [];
  }
};

export default fetchSearchResults;
